export class CompanyGroup {
    constructor(
        public id: number,
        public deleted: boolean,
        public name: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/company/companyGroup/companyGroup.model.ts